import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { ButtonAlign } from '../advanced/buttons/types/ButtonEnums.ts';

export interface IAlignmentSelectInputProps {
  name: string;
  defaultValue?: ButtonAlign;
  placeholder?: string;
}

export function AlignmentSelectInput(props: IAlignmentSelectInputProps) {
  return (
    <SelectInput
      name={props.name}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      options={[
        {
          label: 'Allineato a destra',
          value: ButtonAlign.End,
        },
        {
          label: 'Allineato a sinistra',
          value: ButtonAlign.Start,
        },
        {
          label: 'Allineato al centro',
          value: ButtonAlign.Center,
        },
        {
          label: 'A tutta larghezza',
          value: ButtonAlign.Full,
        },
      ]}
    />
  );
}
